import {
	setRiskNullScore,
	setRiskScores,
	setRiskEditScores,
	setRiskScoreTable,
	setRiskUnitScores,
	setRiskStatus,
	setRiskRunning,
	setRiskLastRun,
	setRiskScoreDataGrid,
	updateRiskScoreDataGrid,
	updateRiskValuesDataGrid,
	setRiskMultiScoreDataGrid,
	updateRiskMultiScoreDataGridRow,
	setDataGridState,
} from '@Actions';
import { GridInitialState } from '@innovyze/stylovyze';

import { createReducer } from '@reduxjs/toolkit';
import { MultiScoreItem } from '@Types/scoreDataGridType';
import {
	UtilReducer,
	UtilStoreState,
	utilStoreStateInitial,
} from '@Types/utils.types';

export interface RiskScoreChange {
	index: number;
	score: number;
}

export interface RiskValueChange {
	index: number;
	value: string;
}

const updateRiskScore = (state: UtilStoreState, action: RiskScoreChange) => {
	const rows = state.riskScoreDataGrid;

	state.riskScoreDataGrid = rows.map(row => {
		if (row.id == action.index) return { ...row, score: action.score };
		else return row;
	});
	return state;
};

const updateRiskMultiScoreRow = (
	state: UtilStoreState,
	action: MultiScoreItem,
) => {
	const rows =
		state.riskMultiScoreEditDataGrid.length == 0
			? state.riskMultiScoreDataGrid
			: state.riskMultiScoreEditDataGrid;

	const id = action['id'];
	state.riskMultiScoreEditDataGrid = rows.map(row => {
		if (row['id'] == id) return action;
		else return row;
	});
	return state;
};

const updateRiskValues = (state: UtilStoreState, action: RiskValueChange[]) => {
	const rows = state.riskScoreDataGrid;

	state.riskScoreDataGrid = rows.map(row => {
		const update = action.find(item => item.index == row.id);
		if (update) return { ...row, value: update.value };
		else return row;
	});
	return state;
};

export interface DataGridStateChange {
	key: string;
	initialState?: GridInitialState;
}

const updateInitialState = (
	state: UtilStoreState,
	action: DataGridStateChange,
) => {
	state.dataGridState[action.key] = action.initialState;
	return state;
};

const reducer: UtilReducer = {
	[setRiskScores.toString()]: (state, action) => ({
		...state,
		riskScores: action.payload,
	}),
	[setRiskEditScores.toString()]: (state, action) => ({
		...state,
		riskEditScores: action.payload,
	}),
	[setRiskUnitScores.toString()]: (state, action) => ({
		...state,
		riskUnitScores: action.payload,
	}),
	[setRiskScoreTable.toString()]: (state, action) => ({
		...state,
		riskScoreTable: action.payload,
	}),
	[setRiskScoreDataGrid.toString()]: (state, action) => ({
		...state,
		riskScoreDataGrid: action.payload,
	}),
	[setRiskMultiScoreDataGrid.toString()]: (state, action) => ({
		...state,
		riskMultiScoreDataGrid: action.payload,
		riskMultiScoreEditDataGrid: [],
	}),
	[setRiskNullScore.toString()]: (state, action) => ({
		...state,
		riskNullScore: action.payload,
	}),
	[setRiskStatus.toString()]: (state, action) => ({
		...state,
		riskStatus: action.payload,
	}),
	[setRiskRunning.toString()]: (state, action) => ({
		...state,
		riskRunning: action.payload,
	}),
	[setRiskLastRun.toString()]: (state, action) => ({
		...state,
		riskLastRun: action.payload,
	}),
	[updateRiskScoreDataGrid.toString()]: (state, action) =>
		updateRiskScore(state, action.payload),
	[updateRiskMultiScoreDataGridRow.toString()]: (state, action) =>
		updateRiskMultiScoreRow(state, action.payload),
	[updateRiskValuesDataGrid.toString()]: (state, action) =>
		updateRiskValues(state, action.payload),
	[setDataGridState.toString()]: (state, action) =>
		updateInitialState(state, action.payload),
};

export const utilReducer = createReducer(utilStoreStateInitial(), reducer);
